const money = (value) => {
  const parsed = Number(value || 0);
  return Number.isFinite(parsed)
    ? Math.round((parsed + Number.EPSILON) * 100) / 100
    : 0;
};

export const isReconciliationCredit = (note) => Boolean(
  String(note?.applicationMode || note?.application_mode || '').toLowerCase() === 'reconciliation'
  || note?.forAdjustmentsOnly
  || String(note?.linkedSuggestionKey || '').trim()
);

export const creditAllocationAmount = (note) => {
  const noteAmount = Math.max(0, money(note?.amount));
  if (!isReconciliationCredit(note)) return noteAmount;

  const target = Math.max(
    0,
    money(
      note?.allocationAmount
      ?? note?.pendingAdjustmentAmount
      ?? note?.linkedAdjustmentAmount
      ?? 0
    )
  );
  return Math.min(noteAmount, target);
};

export const creditRemainingAmount = (note) => (
  Math.max(0, money(money(note?.amount) - creditAllocationAmount(note)))
);
